@if (apiCallInProgress()) {
  <is-wait-message [loadComplete]="!apiCallInProgress()" [useBolt]="false" [waitMessage]="'Please wait while we process your request.'" [timeoutAmount]="0"></is-wait-message>
}

@if (loadComplete()) {
  <form (ngSubmit)="onContinue()" [formGroup]="editPaymentForm.group" class="manage-payment-form-container">
    <div class="bolt-container">
      <bolt-progress-bar appFocusOnInit arialabel="Update automatic payment progress value is 20%" class="progress-bar-container to-container" value="20"></bolt-progress-bar>
      <h1 class="bolt-heading-primary bolt-space-bottom-2xl">Update automatic payment information</h1>
      <div class="bolt-row">
        <div class="bolt-col-12">
          @if (selectedPaymentMethod?.isBankCard) {
            <bolt-notification type="info" class="bolt-space-bottom-2xl to-container">
              <is-interpolate [text]="bankCardAutomaticPaymentsCapMessage"></is-interpolate>
            </bolt-notification>
          }
          @if (globalErrorDisplayable && !accountValidationMessage) {
            <bolt-notification type="error" [id]="'global-error-message'" class="bolt-space-bottom-2xl to-container">Please check the information below and try again.</bolt-notification>
          }
          @if (hasCreditCardVulPolicyError()) {
            <bolt-notification type="error" id="creditCardVulPolicyError" class="bolt-space-bottom-2xl to-container">
              {{ vulErrorMessage() }}
            </bolt-notification>
          }
          <app-payment-sub-header>Payment information</app-payment-sub-header>
          <section id="payment-method-section" class="fluid-container">
            @if (accountValidationMessage) {
              <bolt-notification type="error" id="accountValidationErrorMessageId" class="bolt-space-bottom-2xl to-container">
                {{ accountValidationMessage }}
              </bolt-notification>
            }
            <div class="section-content">
              <div
                [ngClass]="{
                  'bolt-space-bottom-lg': !selectedPaymentMethod?.isBankCard && !selectedPaymentMethod?.isBankAccount,
                }">
                <app-payment-method-section [hasDefaultMethod]="true" [hasSavedPaymentMethod]="true" [(selectedPaymentMethod)]="selectedPaymentMethod"></app-payment-method-section>
              </div>
            </div>
          </section>
          <app-consider-this formGroupName="considerThisGroup" [isAutoPayment]="isAutoPayment"></app-consider-this>
        </div>
        @if (showChangeNotEffectiveWarning) {
          <bolt-notification type="warning" class="bolt-space-bottom-2xl to-container">
            <div><strong>Change not effective this bill.</strong></div>
            <div>
              The changed pay method for automatic payments will begin on
              {{ nextBillingPaymentDate }}.
            </div>
          </bolt-notification>
        } @else if (showChangeEffectiveImmediately) {
          <bolt-notification type="info" class="bolt-space-bottom-2xl to-container">
            <div><strong>Change effective immediately.</strong></div>
            <div>
              The changes made to automatic payments will begin on
              {{ todayDisplayDate }}.
            </div>
          </bolt-notification>
        }

        <bolt-notification type="info" class="bolt-space-bottom-2xl to-container">
          If there is a change in your premium amount you'll receive a notification before any automatic payment is processed.
        </bolt-notification>
      </div>
    </div>
    <bolt-button-bar>
      <bolt-button slot="cancel" id="cancel-button" (click)="cancelEditPayment()">Cancel</bolt-button>
      <bolt-button submit slot="forward" type="solid" id="continue-button" [disabled]="showEFTAuthFormValidationMessage && chosenPaymentMethod?.isBankAccount">Continue</bolt-button>
    </bolt-button-bar>
  </form>
}
